import { useTheme } from "@mui/material";
import axios from "axios";
import cn from "classnames";
import { BrowserProvider, Contract, formatUnits, parseUnits } from "ethers";
import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-hot-toast";
import { BiLoaderAlt } from "react-icons/bi";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ReactComponent as AddNewImg } from "../../../assets/addNew.svg";
import {
  NewCheck,
  USDTimg,
  XBRimg,
  XbrWhite,
  tba,
} from "../../../assets/index.js";
import ConnectWalletButtonMain from "../../../components/ConnectWalletButtonMain.jsx";
import FailedTransaction from "../../../components/FailedTransaction.jsx";
import LiquidityConfirmationModal from "../../../components/LiquidityConfirmationModal.jsx";
import LiquidityConfirmedModal from "../../../components/LiquidityConfirmedModal.jsx";
import { selectThemeMode } from "../../../redux/theme/themeSlice.js";
import { findPoolAddress } from "../../../uniswap/pool.js";
import {
  getEstimatedValueForLiquiditynew,
  getTokenTransferApproval,
} from "../../../uniswap/position";
import {
  mintPositionNew,
} from "../../../uniswap/position";
import { fetchTokenAddress } from "../../../uniswap/utils";
import { ERC20_ABI } from "../../../web3Utils";
import { TBA_TOKEN, USDT_TOKEN, XBR_TOKEN } from "../../../web3Utils.js";
import LiquidityCard from "../LiquidityCard/LiquidityCard.jsx";
import TokenExchangeRate from "../TokenExchangeRate/TokenExchangeRate.jsx";
import { useContextProvider } from '../../../context/index.jsx';
import { getEthersSigner } from '../../../utils/wagmi.utils.js';

const AddLiquidity = (props) => {
  const theme = useTheme();
		const {walletAddress, jsonRpcProvider}= useContextProvider();
  const { setMainActiveSection } = props;

  const [sendValue, setSendValue] = useState("");
  const [receiveValue, setReceiveValue] = useState("");
  const [usdtBalance, setUsdtBalance] = useState(0);
  const [xbrBalance, setXbrBalance] = useState(0);
  const [tbaBalance, setTbaBalance] = useState(0);
  const [isToken1Approved, setIsToken1Approved] = useState(false);
  const [isToken2Approved, setIsToken2Approved] = useState(false);
  const [isUSDTLoader, setIsUSDTLoader] = useState(false);
  const [isXBRLoader, setIsXBRLoader] = useState(false);
  const [isInsufficientBalance, setIsInsufficientBalance] = useState(false);
  const [isInsufficientBalance1, setIsInsufficientBalance1] = useState(false);
  const [isInsufficientBalance2, setIsInsufficientBalance2] = useState(false);
  const [selectedPriceXBR, setSelectedPriceXBR] = useState("");
  const [selectedPriceTBA, setSelectedPriceTBA] = useState("");
  const [usdtPrice, setUsdtPrice] = useState("");
  const [usdt1, setUsdt1] = useState("0.00");
  const [usdt2, setUsdt2] = useState("0.00");

  const currentMode = useSelector(selectThemeMode);

  const tokens = [
    {
      id: "XBR",
      name: "XBR",
      image: currentMode === "light" ? XbrWhite : XBRimg,
    },
    {
      id: "USDT",
      name: "USDT",
      image: USDTimg,
    },
    {
      id: "TBA",
      name: "TBA",
      image: tba,
    },
  ];

  const [selectedToken1, setSelectedToken1] = useState(tokens[1]);
  const [selectedToken2, setSelectedToken2] = useState(tokens[0]);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const dropdownRef1 = useRef(null);
  const dropdownRef2 = useRef(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isTransactionFailed, setIsTransactionFailed] = useState(false);
  const [isAddConfirmed, setIsAddConfirmed] = useState(false);

  const fetchBalances = async (walletAddress, jsonRpcProvider) => {
    try {

      if (!walletAddress) return;

      const usdcContract = new Contract(
        USDT_TOKEN.address,
        ERC20_ABI,
        jsonRpcProvider
      );
      const xbrContract = new Contract(XBR_TOKEN.address, ERC20_ABI, jsonRpcProvider);
      const tbaContract = new Contract(TBA_TOKEN.address, ERC20_ABI, jsonRpcProvider);

      const usdcBalance = formatUnits(await usdcContract.balanceOf(walletAddress), 6);
      const xbrBalance = formatUnits(await xbrContract.balanceOf(walletAddress), 18);
      const tbaBalance = formatUnits(await tbaContract.balanceOf(walletAddress), 18);

      setUsdtBalance(usdcBalance);
      setXbrBalance(xbrBalance);
      setTbaBalance(tbaBalance);
    } catch (error) {
      console.error("Error fetching balances:", error);
    }
  };

  useEffect(() => {
		if (walletAddress && jsonRpcProvider)
    fetchBalances(walletAddress, jsonRpcProvider);
  }, [walletAddress]);


  const fetchMarketData = async (jsonRpcProvider) => {
    try {
      const XBR = await fetchTokenAddress("XBR", jsonRpcProvider);
      const USDT = await fetchTokenAddress("USDT", jsonRpcProvider);
      const TBA = await fetchTokenAddress("TBA", jsonRpcProvider);

      const poolAddressXBR = await findPoolAddress(
        USDT.address,
        XBR.address,
        jsonRpcProvider
      );

      const poolAddressTBA = await findPoolAddress(
        USDT.address,
        TBA.address,
        jsonRpcProvider
      );

      const URL = process.env.REACT_APP_API;
      const responsesXBR = await axios.get(`${URL}/v1/xbr/coin-price?`, {
        params: {
          address: poolAddressXBR.poolAddress,
          count: 157860000,
        },
      });
      const coinMarketCapDataXBR = await responsesXBR.data.response
        .coinMarketCapResponseData.data;
      const priceXBR = await coinMarketCapDataXBR?.priceUsd;

      setSelectedPriceXBR(priceXBR);
      const responsesTBA = await axios.get(`${URL}/v1/xbr/coin-price?`, {
        params: {
          address: poolAddressTBA.poolAddress,
          count: 157860000,
        },
      });
      const coinMarketCapDataTBA = await responsesTBA.data.response
        .coinMarketCapResponseData.data;
      const priceTBA = await coinMarketCapDataTBA?.priceUsd;
      setSelectedPriceTBA(priceTBA);
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  const pricemap = {
    XBR: selectedPriceXBR,
    TBA: selectedPriceTBA,
    USDT: usdtPrice,
  };

  const fetchUsdtPrice = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/v1/xbr/usdt-price`
      );
      return response.data?.usd;
    } catch (error) {
      console.error("Error in fetching USDT Price", error);
    }
  };

  const fetchUSDTPrice = async () => {
    const price = await fetchUsdtPrice();
    setUsdtPrice(await price);
  };

  useEffect(() => {
    if (walletAddress && jsonRpcProvider) {
      fetchMarketData(jsonRpcProvider);
    }
    fetchUSDTPrice();
  }, [selectedToken1, selectedToken2, walletAddress]);

  function formatTbaPrice(price) {
    // Ensure the price is a number
    if (typeof price !== "number" || isNaN(price)) return "NaN";

    // Convert the price to a string in fixed-point notation to ensure precision
    let priceStr = price.toFixed(25); // Use enough precision to capture all significant digits

    // Find the index of the decimal point
    let decimalIndex = priceStr.indexOf(".") + 1;

    // Find the index of the first non-zero digit after the decimal point
    let firstNonZeroIndex = decimalIndex;
    while (
      priceStr[firstNonZeroIndex] === "0" &&
      firstNonZeroIndex < priceStr.length
    ) {
      firstNonZeroIndex++;
    }

    // Count the number of leading zeroes
    let zeroCount = firstNonZeroIndex - decimalIndex;

    // Get the significant digits part (adjust the length as needed)
    let significantPart = priceStr.substring(
      firstNonZeroIndex,
      firstNonZeroIndex + 3
    );

    // Construct the formatted string
    return `0.0(${zeroCount})${significantPart}`;
  }

  const fetchPrice = async (address) => {
    const URL = `${process.env.REACT_APP_API}/v1/xbr/token-prices?address=${address}`;
    const response = await axios.get(URL);
    return response?.data?.data?.attributes?.price_usd;
  };

  const fetch1USDT = async (jsonRpcProvider) => {
    const quotes1 = await getEstimatedValueForLiquiditynew(
      selectedToken1.name,
      selectedToken2.name,
      1,
      jsonRpcProvider
    );
    const quotes2 = await getEstimatedValueForLiquiditynew(
      selectedToken2.name,
      selectedToken1.name,
      1,
      jsonRpcProvider
    );

    if (selectedToken1.name === "TBA") {
      const TBA = await fetchPrice(
        "0x7e1AE068Ac4e0ffD7a84750c2FB093A0EAE9aEa2"
      );
      setUsdt1(formatTbaPrice(Number(TBA)));
      setUsdt2(formatBalanceForPrice(quotes2));
    } else if (selectedToken2.name === "TBA") {
      const TBA = await fetchPrice(
        "0x7e1AE068Ac4e0ffD7a84750c2FB093A0EAE9aEa2"
      );
      setUsdt1(formatBalanceForPrice(quotes1));
      setUsdt2(formatTbaPrice(Number(TBA)));
    } else {
      setUsdt1(formatBalanceForPrice(quotes1));
      setUsdt2(formatBalanceForPrice(quotes2));
    }
  };

  useEffect(() => {
    if (walletAddress && jsonRpcProvider) {
      fetch1USDT(jsonRpcProvider);
    }
  }, [selectedToken1, selectedToken2, walletAddress]);

  const handleApprove = async (type) => {
    try {
			const signer = await getEthersSigner()
      let tokenAddress, tokenAmount, weiType;

      if (type === selectedToken1.name) {
        weiType =
          selectedToken1.id === "XBR" || selectedToken1.id === "TBA" ? 18 : 6;
        tokenAmount = parseFloat(sendValue).toFixed(weiType);
        setIsUSDTLoader(true);

        tokenAddress =
          selectedToken1.id === "TBA"
            ? TBA_TOKEN.address
            : selectedToken1.id === "XBR"
            ? XBR_TOKEN.address
            : USDT_TOKEN.address;
      } else if (type === selectedToken2.name) {
        weiType =
          selectedToken2.id === "XBR" || selectedToken2.id === "TBA" ? 18 : 6;
        tokenAmount = parseFloat(receiveValue).toFixed(weiType);
        setIsXBRLoader(true);

        tokenAddress =
          selectedToken2.id === "TBA"
            ? TBA_TOKEN.address
            : selectedToken2.id === "XBR"
            ? XBR_TOKEN.address
            : USDT_TOKEN.address;
      }

      if (
        Number(tokenAmount) === 0 ||
        isNaN(Number(tokenAmount)) ||
        Number(tokenAmount) === ""
      ) {
        toast.error("Please enter a valid token amount");
        return;
      }

      const weiAmount = parseUnits(tokenAmount.toString(), weiType);
      const approval = await getTokenTransferApproval(
        { address: tokenAddress },
        weiAmount,
        signer
      );

      if (
        approval !== null &&
        approval !== "" &&
        approval !== undefined &&
        approval !== "Failed"
      ) {
        if (type === selectedToken1.name) {
          setIsToken1Approved(true);
        } else {
          setIsToken2Approved(true);
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setIsUSDTLoader(false);
      setIsXBRLoader(false);
    }
  };

  const formatBalanceForPrice = (balance) => {
    const num = parseFloat(balance);
    if (num >= 1e12) {
      return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T";
    } else if (num >= 1e9) {
      return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      return num.toFixed(4).replace(/\.?0+$/, "");
    }
  };

  const getFormattedBalance = (name) => {
    const balanceMap = {
      XBR: `${formatBalanceForPrice(xbrBalance)}`,
      USDT: `${formatBalanceForPrice(usdtBalance)}`,
      TBA: `${formatBalanceForPrice(tbaBalance)}`,
    };
    return balanceMap[name] || "0.00";
  };

  const newMax = (type, inputType) => {
    try {
      const balanceMap = {
        XBR: xbrBalance,
        USDT: usdtBalance,
        TBA: tbaBalance,
      };

      const balance = balanceMap[type] || "0.00";

      newOnChangeSwapInputs(
        balance,
        type,
        inputType,
        type === selectedToken1.name ? selectedToken2.name : selectedToken1.name
      );
    } catch (error) {
      console.error("Error getting max balances", error);
    }
  };

  const newOnChangeSwapInputs = async (value, type, data, type2) => {
    if (!value || value === undefined || value === null || value === "") {
      setSendValue("");
      setReceiveValue("");
      setIsInsufficientBalance1(false);
      setIsInsufficientBalance2(false);
      return;
    }

    const regex = /^(?!-)[0-9]*[.]?[0-9]*$/;
    if (!regex.test(value)) {
      return; // Prevent invalid input
    }

    try {
      const balanceMap = {
        XBR: parseFloat(xbrBalance),
        USDT: parseFloat(usdtBalance),
        TBA: parseFloat(tbaBalance),
      };

      const balance = balanceMap[type] || 0;
      const parsedValue = parseFloat(value) || 0;

      if (data === 1) {
        setSendValue(value);
        const result =
          parsedValue > 0
            ? await getEstimatedValueForLiquiditynew(
                type,
                type2,
                value,
                jsonRpcProvider
              )
            : "";
        setReceiveValue(result);
        setIsInsufficientBalance1(parsedValue > balance);
        setIsInsufficientBalance2(false);
      } else {
        setReceiveValue(value);
        const result =
          parsedValue > 0
            ? await getEstimatedValueForLiquiditynew(
                type,
                type2,
                value,
                jsonRpcProvider
              )
            : "";
        setSendValue(result);
        setIsInsufficientBalance2(parsedValue > balance);
        setIsInsufficientBalance1(false); // Reset the first box's error
      }
      checkInsufficientBalance();
      setIsToken1Approved(false);
      setIsToken2Approved(false);
    } catch (error) {
      console.error("Error in swap input:", error);
    }
  };
  useEffect(() => {
    if (sendValue) {
      newOnChangeSwapInputs(
        sendValue,
        selectedToken1.name,
        1,
        selectedToken2.name
      );
    }
    if (receiveValue) {
      newOnChangeSwapInputs(
        receiveValue,
        selectedToken2.name,
        2,
        selectedToken1.name
      );
    }
  }, [selectedToken1, selectedToken2]);

  const swapTokens = () => {
    const temp = selectedToken1;
    setSelectedToken1(selectedToken2);
    setSelectedToken2(temp);

    const tempAmount = sendValue;
    setSendValue(receiveValue);
    setReceiveValue(tempAmount);
  };

  const handleTokenChange = (token, isFirst) => {
    if (isFirst) {
      // if (isForbiddenPair(token.name, selectedToken2.name)) {
      //   return;
      // }
      setIsToken1Approved(false);
      setIsToken2Approved(false);
      if (token.id === selectedToken2.id) {
        swapTokens();
      } else {
        setSelectedToken1(token);
        if (sendValue) {
          newOnChangeSwapInputs(sendValue, token.name, 1, selectedToken2.name);
        }
      }
    } else {
      setIsToken1Approved(false);
      setIsToken2Approved(false);
      if (token.id === selectedToken1.id) {
        swapTokens();
      } else {
        setSelectedToken2(token);
        if (receiveValue) {
          newOnChangeSwapInputs(
            receiveValue,
            token.name,
            2,
            selectedToken1.name
          );
        }
      }
    }
    checkInsufficientBalance();
  };

  const checkInsufficientBalance = () => {
    const parsedSendValue = parseFloat(sendValue) || 0;
    const parsedReceiveValue = parseFloat(receiveValue) || 0;

    const isInsufficientToken1Balance =
      (selectedToken1.name === "USDT" &&
        parsedSendValue > parseFloat(usdtBalance)) ||
      (selectedToken1.name === "XBR" &&
        parsedSendValue > parseFloat(xbrBalance)) ||
      (selectedToken1.name === "TBA" &&
        parsedSendValue > parseFloat(tbaBalance));

    const isInsufficientToken2Balance =
      (selectedToken2.name === "USDT" &&
        parsedReceiveValue > parseFloat(usdtBalance)) ||
      (selectedToken2.name === "XBR" &&
        parsedReceiveValue > parseFloat(xbrBalance)) ||
      (selectedToken2.name === "TBA" &&
        parsedReceiveValue > parseFloat(tbaBalance));

    setIsInsufficientBalance1(isInsufficientToken1Balance);
    setIsInsufficientBalance2(isInsufficientToken2Balance);

    setIsInsufficientBalance(
      isInsufficientToken1Balance || isInsufficientToken2Balance
    );
  };
  useEffect(() => {
    checkInsufficientBalance();
  }, [sendValue, receiveValue, selectedToken1, selectedToken2]);

  useEffect(() => {
    checkInsufficientBalance();
  }, [sendValue, receiveValue, selectedToken1, selectedToken2]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setIsOpen1(false);
      }
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setIsOpen2(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function safeParseNumber(value) {
    const number = Number(value);
    return isNaN(number) ? 0 : number;
  }

  const handleAddLiquidity = async () => {
    setIsConfirmModalOpen(true);

    try {
      let adjustedSendValue = Number(sendValue);
      let adjustedReceiveValue = Number(receiveValue);

      const tokenPairAdjustments = {
        "XBR-USDT": () => {
          [adjustedSendValue, adjustedReceiveValue] = [
            adjustedReceiveValue,
            adjustedSendValue,
          ];
        },
        "USDT-TBA": () => {
          [adjustedSendValue, adjustedReceiveValue] = [
            adjustedReceiveValue,
            adjustedSendValue,
          ];
        },
        "XBR-TBA": () => {
          [adjustedSendValue, adjustedReceiveValue] = [
            adjustedReceiveValue,
            adjustedSendValue,
          ];
        },
      };

      const tokenPairKey = `${selectedToken1.name}-${selectedToken2.name}`;

      if (tokenPairAdjustments[tokenPairKey]) {
        tokenPairAdjustments[tokenPairKey]();
      }
			const signer = await getEthersSigner()
      const mint = await mintPositionNew(
        adjustedSendValue,
        adjustedReceiveValue,
        selectedToken1.name,
        selectedToken2.name,
        jsonRpcProvider,
				walletAddress,
				signer
      );

      if (
        mint !== "Failed" &&
        mint !== null &&
        mint !== "" &&
        mint !== undefined
      ) {
        setIsConfirmModalOpen(false);
        setIsAddConfirmed(true);
        setTimeout(() => {
          setIsAddConfirmed(false);
          setSendValue(0);
          setReceiveValue(0);
          setIsToken1Approved(false);
          setIsToken2Approved(false);
        }, 15000);
      } else {
        // Handle failure case
        // toast.error("Liquidity addition failed");
      }

      if (
        mint === "Failed" ||
        mint === null ||
        mint === "" ||
        mint === undefined
      ) {
        setIsTransactionFailed(true);
      } else {

        setTimeout(() => {
          setIsToken1Approved(false);
          setIsToken2Approved(false);
          window.location.reload();
        }, 15000);
      }
    } catch (error) {
      console.error("Error at Add Liquidity:", error);
    } finally {
      setIsConfirmModalOpen(false);
    }
  };
  useEffect(() => {
    if (isAddConfirmed || isConfirmModalOpen) {
      // Disable background scrolling
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable background scrolling
      document.body.style.overflow = "auto";
    }

    // Clean up when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isConfirmModalOpen, isAddConfirmed]);

  const changeTokenOneValue = (event) => {
    const inputValue = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/^(\.)/, "")
      .replace(/\.(?=.*\.)/g, "")
      .replace(/[eE+-]/g, "");

    newOnChangeSwapInputs(
      inputValue,
      selectedToken1.name,
      1,
      selectedToken2.name
    );
    checkInsufficientBalance();
    setIsToken1Approved(false);
  };

  const changeTokenTwoValue = (event) => {
    const inputValue = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/^(\.)/, "")
      .replace(/\.(?=.*\.)/g, "")
      .replace(/[eE+-]/g, "");

    newOnChangeSwapInputs(
      inputValue,
      selectedToken2.name,
      2,
      selectedToken1.name
    );
    checkInsufficientBalance();
    setIsToken2Approved(false);
  };

  const chooseTokenOne = (token) => {
    handleTokenChange(token, true);
    setIsOpen1(false);
  };
  const chooseTokenTwo = (token) => {
    handleTokenChange(token, false);
    setIsOpen2(false);
  };

  const setNewMaxForTokenOne = () => {
    newMax(selectedToken1.name, 1);
  };

  const setNewMaxForTokenTwo = () => {
    newMax(selectedToken2.name, 2);
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="flex flex-col gap-4 w-full relative mb-6">
        {/* card 1 */}

        <LiquidityCard
          cardName={"Token 1"}
          paletteMode={theme.palette.mode}
          dropdownRef={dropdownRef1}
          setIsOpen={setIsOpen1}
          isOpen={isOpen1}
          tokens={tokens}
          selectedToken={selectedToken1}
          getFormattedBalance={getFormattedBalance}
          formatBalanceForPrice={formatBalanceForPrice}
          safeParseNumber={safeParseNumber}
          tokenValue={sendValue}
          pricemap={pricemap}
          changeTokenValue={changeTokenOneValue}
          handleTokenChange={chooseTokenOne}
          setNewMax={setNewMaxForTokenOne}
        />

        {/* Swap button */}
        <button
          type="button"
          className="w-10 h-10 bg-white rounded-lg border dark:bg-darkCardBg dark:hover:!bg-[#3C3A66] border-skyBlue transition-colors duration-300 hover:bg-[#F0F4FF] active:bg-[#D8E2FF] absolute top-[calc(50%-20px)] left-1/2 transform -translate-x-1/2 flex items-center justify-center z-20 shadow-swapButton"
          onClick={swapTokens}
        >
          <AddNewImg className="text-skyBlue w-6 h-6" />
        </button>

        {/* card 2 */}

        <LiquidityCard
          paletteMode={theme.palette.mode}
          cardName={"Token 2"}
          dropdownRef={dropdownRef2}
          setIsOpen={setIsOpen2}
          isOpen={isOpen2}
          tokens={tokens}
          selectedToken={selectedToken2}
          getFormattedBalance={getFormattedBalance}
          formatBalanceForPrice={formatBalanceForPrice}
          safeParseNumber={safeParseNumber}
          tokenValue={receiveValue}
          pricemap={pricemap}
          changeTokenValue={changeTokenTwoValue}
          handleTokenChange={chooseTokenTwo}
          setNewMax={setNewMaxForTokenTwo}
          connectedAccount={walletAddress}
          setMainActiveSection={setMainActiveSection}
          isInsufficientBalance={isInsufficientBalance}
        />
      </div>

      <div className="flex justify-center gap-3 w-full mb-6">
        <TokenExchangeRate
          usdt={usdt1}
          selectedTokenOneName={selectedToken2.name}
          selectedTokenTwoName={selectedToken1.name}
        />
        <TokenExchangeRate
          usdt={usdt2}
          selectedTokenOneName={selectedToken1.name}
          selectedTokenTwoName={selectedToken2.name}
        />
      </div>

      {walletAddress && (
        <div className="flex mb-4 gap-2 w-full">
          <button
            type="button"
            className={cn(
              "w-full h-14 flex-1 text-base leading-6 font-medium rounded-lg border text-white border-white shadow-swapButton transition-colors duration-300 bg-deepBlue dark:bg-darkCardBg hover:bg-vividBlueViolet flex items-center justify-center",
              {
                "!text-semiBlack bg-lightBlue border-none dark:!text-semiWhite dark:!bg-darkButBg !shadow-none  pointer-events-none":
                  isUSDTLoader || !sendValue || isInsufficientBalance1,
              }
            )}
            onClick={() => {
              if (!isToken1Approved && !isUSDTLoader) {
                handleApprove(selectedToken1.name);
              }
            }}
            disabled={isUSDTLoader || !sendValue || isInsufficientBalance1}
          >
            {isUSDTLoader ? (
              <div>
                <BiLoaderAlt className="animate-spin text-gray-50" />
              </div>
            ) : isToken1Approved ? (
              <>
                <span
                  className={cn("flex gap-1 flex-row items-center", {
                    "opacity-70": isToken2Approved,
                  })}
                >
                  <img
                    alt="NewCheck"
                    src={NewCheck}
                    className="w-4 h-4 mt-[2px] rounded-[12px]"
                  />
                  Approved {selectedToken1.name}
                </span>
              </>
            ) : (
              `Approve ${selectedToken1.name}`
            )}
          </button>

          {/* Approve Button for second token */}
          <button
            type="button"
            className={cn(
              "w-full h-14 flex-1 text-base leading-6 font-medium rounded-lg border text-white border-white shadow-swapButton transition-colors duration-300 bg-deepBlue dark:bg-darkCardBg hover:bg-vividBlueViolet flex items-center justify-center",
              {
                "!text-semiBlack bg-lightBlue border-none dark:!text-semiWhite dark:!bg-darkButBg !shadow-none  pointer-events-none":
                  isXBRLoader || !receiveValue || isInsufficientBalance2,
              }
            )}
            onClick={() => {
              if (!isToken2Approved && !isXBRLoader) {
                handleApprove(selectedToken2.name);
              }
            }}
            disabled={isXBRLoader || !receiveValue || isInsufficientBalance2}
          >
            {isXBRLoader ? (
              <div>
                <BiLoaderAlt className="animate-spin text-gray-50" />
              </div>
            ) : isToken2Approved ? (
              <>
                <span
                  className={cn("flex gap-1 flex-row items-center", {
                    "opacity-70": isToken2Approved,
                  })}
                >
                  <img
                    alt="NewCheck"
                    src={NewCheck}
                    className="w-4 h-4 mt-[2px] rounded-[12px]"
                  />
                  Approved {selectedToken2.name}
                </span>
              </>
            ) : (
              `Approve ${selectedToken2.name}`
            )}
          </button>
        </div>
      )}
      <div className="w-full z-10">
        {walletAddress ? (
          <button
            type={"button"}
            className={cn(
              "w-full h-14 text-base leading-6 font-medium rounded-lg border text-white border-white shadow-swapButton transition-colors  bg-deepBlue dark:bg-darkCardBg dark:text-semiWhite hover:bg-vividBlueViolet active:!bg-[#1E31FF] transition-all duration-300 flex items-center justify-center",
              {
                "!text-semiBlack bg-lightBlue border-none dark:!text-semiWhite dark:!bg-darkButBg !shadow-none  pointer-events-none":
                  isInsufficientBalance ||
                  !isToken1Approved ||
                  !isToken2Approved,
              }
            )}
            onClick={() => {
              setIsConfirmModalOpen(true);
              handleAddLiquidity();
            }}
            disabled={
              isInsufficientBalance || !isToken1Approved || !isToken2Approved
            }
          >
            {isInsufficientBalance
              ? "Insufficient balance"
              : sendValue && receiveValue
              ? "Add Liquidity"
              : "Enter Amount"}
          </button>
        ) : (
          <ConnectWalletButtonMain />
        )}
      </div>
      {isConfirmModalOpen && (
        <LiquidityConfirmationModal
          onClose={() => setIsConfirmModalOpen(false)}
          text={`Supplying ${sendValue} ${selectedToken1.name} and ${receiveValue} ${selectedToken2.name}`}
        />
      )}
      {isAddConfirmed && (
        <LiquidityConfirmedModal
          onClose={() => {
            setIsAddConfirmed(false);
            setSendValue(0);
            setReceiveValue(0);
            setIsToken1Approved(false);
            setIsToken2Approved(false);
          }}
          text={"Added Liquidity"}
          paragraph={`${sendValue} ${selectedToken1.name} and ${receiveValue} ${selectedToken2.name}`}
          token0Name={selectedToken1.name}
          token1Name={selectedToken2.name}
        />
      )}
      {isTransactionFailed && (
        <FailedTransaction onClose={() => setIsTransactionFailed(false)} />
      )}
    </div>
  );
};

export default AddLiquidity;
